import { Badge } from "antd"
import React from "react"

// Deliberately softer than antd's default Badge red (`#FF4D4F`) and the
// Error/Danger token in UI_UX_GUIDELINES.md (`red-500` #EF4444 on `red-50`)
// — Phase 1 asks for an indication, not an alarm, so this steps one notch
// down the same red ramp: a light pastel background with a muted, still
// legible, foreground.
const PASTEL_BADGE_STYLE: React.CSSProperties = {
  backgroundColor: "#FEE2E2",
  color: "#B91C1C",
  boxShadow: "none",
  fontWeight: 600
}

interface NotificationBadgeProps {
  count: number
  children?: React.ReactNode
  offset?: [number, number]
  className?: string
}

// Shows nothing when there is nothing new — a badge here is meant to read as
// "something changed", never as a permanent zero.
export const NotificationBadge = ({
  count,
  children,
  offset,
  className
}: NotificationBadgeProps) => {
  if (!count) return children ?? null

  return (
    <Badge
      count={count}
      size="small"
      offset={offset}
      style={PASTEL_BADGE_STYLE}
      className={className}
    >
      {children}
    </Badge>
  )
}
